// extracted by mini-css-extract-plugin
module.exports = {"editStageFormWrp":"editStage_editStageFormWrp__uux_q","textBox":"editStage_textBox__3lWqR","removeWrp":"editStage_removeWrp__2sieb"};